import { Switch } from "components-redesign";
import { TypographyBodyLarge } from "components-redesign/Typography/Typography";
import { FlexContent } from "components/FlexContent/FlexContent";
import { Menu, makeStyles } from "components/mui-core";
import { isLocal } from "configuration/endpoints";
import { ReactComponent as FeatureTogglesIcon } from "icons/navbar/infoMenuItems/feature-toggles.svg";
import React from "react";
import { useFeatureTogglesList } from "../../../configuration/featureToggles/useFeatureToggles";
import { useInfoMenuStyles } from "./styles";

const useFeatureTogglesStyles = makeStyles()({
  root: {
    padding: "8px 0",
    color: "#fff",
    width: "100%",
  },
  sectionTitle: {
    padding: "8px 16px 4px",
    color: "rgba(255,255,255,0.5)",
    fontSize: 10,
    textTransform: "uppercase",
    letterSpacing: "0.08em",
  },
  item: {
    height: "56px",
    padding: "0 16px",
  },
  alphaItem: {
    height: "40px",
    padding: "0 16px",
  },
  toggle: {
    margin: 0,
    marginRight: 0,
  },
});

function FeatureToggles({
  onActive,
}: {
  onActive?: (active: boolean) => void;
}) {
  const { classes } = useInfoMenuStyles();
  const { classes: ownClasses } = useFeatureTogglesStyles();
  const toggles = useFeatureTogglesList();
  const [fetaureToggleAnchor, setFeatureToggleAnchor] =
    React.useState<Element | null>(null);

  React.useEffect(() => {
    onActive?.(Boolean(fetaureToggleAnchor));
  }, [fetaureToggleAnchor, onActive]);

  React.useEffect(() => {
    toggles.forEach(({ id, onChange }) => {
      const keyExists = localStorage.getItem(id);
      onChange(!!keyExists);
    });
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  const saveToLocalStorage = (id: string, enabled: boolean) => {
    if (enabled) {
      localStorage.setItem(id, "enabled");
    } else {
      localStorage.removeItem(id);
    }
  };

  const alphaToggles = toggles.filter((t) => t.showInAlpha);
  const manualToggles = toggles.filter((t) => !t.showInAlpha);

  return (
    <>
      <div onClick={(e: any) => setFeatureToggleAnchor(e.currentTarget)}>
        <FeatureTogglesIcon />
      </div>
      <Menu
        PopoverClasses={{ paper: classes.darkMenu }}
        anchorEl={fetaureToggleAnchor}
        open={Boolean(fetaureToggleAnchor)}
        onClose={() => setFeatureToggleAnchor(null)}>
        <div className={ownClasses.root}>
          {alphaToggles.length > 0 && (
            <>
              <div className={ownClasses.sectionTitle}>Enabled in alpha</div>
              {alphaToggles.map(
                ({ id, label, onChange, value, reloadOnToggle }) => (
                  <FlexContent
                    align="center"
                    justify={isLocal ? "space-between" : undefined}
                    key={id}
                    className={ownClasses.alphaItem}>
                    <TypographyBodyLarge title={id}>
                      {label}
                    </TypographyBodyLarge>
                    {isLocal && (
                      <Switch
                        label=""
                        variant="no-icon-thumb"
                        classes={{
                          container: ownClasses.toggle,
                        }}
                        checked={value as boolean}
                        onChange={(newValue) => {
                          onChange(newValue);
                          saveToLocalStorage(id, newValue);
                          if (reloadOnToggle) {
                            window.location.reload();
                          }
                        }}
                      />
                    )}
                  </FlexContent>
                )
              )}
            </>
          )}
          {manualToggles.length > 0 && (
            <>
              <div className={ownClasses.sectionTitle}>Manually enable</div>
              {manualToggles.map(
                ({ id, label, onChange, value, reloadOnToggle }) => (
                  <FlexContent
                    align="center"
                    justify="space-between"
                    key={id}
                    className={ownClasses.item}>
                    <TypographyBodyLarge title={id}>
                      {label}
                    </TypographyBodyLarge>
                    <Switch
                      label=""
                      variant="no-icon-thumb"
                      classes={{
                        container: ownClasses.toggle,
                      }}
                      checked={value as boolean}
                      onChange={(newValue) => {
                        onChange(newValue);
                        saveToLocalStorage(id, newValue);
                        if (reloadOnToggle) {
                          window.location.reload();
                        }
                      }}
                    />
                  </FlexContent>
                )
              )}
            </>
          )}
        </div>
      </Menu>
    </>
  );
}

export default FeatureToggles;
